import { includes, join, mapValues } from "lodash-es";

export interface IAddressComponents {
    street: string;
    street2?: string;
    city: string;
    state?: string;
    zipCode?: string;
    country: string;
}

const componentMap: { [component: string]: string[] } = {
    streetNumber: ["street_number"],
    streetAddress: ["street_address", "route"],
    city: [
        "locality",
        "postal_town",
        "sublocality",
        "sublocality_level_1",
        "sublocality_level_2",
        "sublocality_level_3",
        "sublocality_level_4",
    ],
    state: [
        "administrative_area_level_1",
        "administrative_area_level_2",
        "administrative_area_level_3",
        "administrative_area_level_4",
        "administrative_area_level_5",
    ],
    postalCode: ["postal_code"],
    country: ["country"],
};

export const getAddressObject = (addressComponents: google.maps.GeocoderAddressComponent[]): IAddressComponents => {
    const address: { [component: string]: string } = {
        streetNumber: "",
        streetAddress: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
    };

    // Google Places API returns a list of address components with a long name, short name, and a
    // list of "types" in order from most to least precise. We loop through each of these
    // components, and match the most precise type against our mapping defined in componentMap to
    // see if there is a match. If so, we update our address.
    //
    // More details on the "types" can be found here:
    // https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
    addressComponents.forEach((component) => {
        Object.keys(componentMap).map((c) => {
            if (includes(componentMap[c], component.types[0])) {
                // Google Places API provides both short and long names, and for some
                // fields we just want the short / abbreviated name.
                if (includes(["country", "state", "streetAddress"], c)) {
                    address[c] = component.short_name;
                } else {
                    address[c] = component.long_name;
                }
            }
        });
    });

    return handleAddressExceptions(
        mapValues(
            {
                street: join([address.streetNumber, address.streetAddress], " "),
                city: address.city,
                state: address.state,
                zipCode: address.postalCode,
                country: address.country,
            },
            (value) => value.trim(),
        ),
    );
};

const handleAddressExceptions = (address: IAddressComponents): IAddressComponents => {
    if (address.country === "HK") {
        address.city = "Hong Kong";
    }

    if (address.country === "MO") {
        address.city = "Macao";
    }

    return address;
};
